/**
 * stockIdSort.ts - Reusable numeric Stock ID comparator.
 * Stock IDs have format LAP-XXXXXX (e.g. LAP-000054).
 * Sorts by the numeric suffix only.
 */
export function getStockIdNumericSuffix(stockId: string): number {
  const match = stockId.match(/\d+$/);
  return match ? parseInt(match[0], 10) : 0;
}

export function compareByStockId(a: { stock_id: string }, b: { stock_id: string }): number {
  return getStockIdNumericSuffix(a.stock_id) - getStockIdNumericSuffix(b.stock_id);
}
